import { NGXLogger } from "ngx-logger";
import { authAs, authType, ILayer } from "../definitions";
import { MapController } from "./map-controller";
import { getExMessage } from "./map-utils";


import Control from 'ol/control/Control';
import Overlay from 'ol/Overlay';
import Geolocation from 'ol/Geolocation';
import * as olCoordinate from 'ol/coordinate';
import MousePosition from "ol/control/MousePosition";
import ScaleLine from 'ol/control/ScaleLine';
import Stroke from "ol/style/Stroke";
import Compass from "ol-ext/control/Compass";
import * as olProj from 'ol/proj';


export class MapCtrlTools {

    constructor(private mapCtrl: MapController, private $log : NGXLogger){

    }

    //map left tool controls
    //
    public addIntegrateLandsatHotspotButton() {
        this.mapCtrl.integrateLandsatHotspotButton = document.createElement('button');
        this.mapCtrl.integrateLandsatHotspotButton.innerHTML = '<i class="fas fa-temperature-high"></i>';
        this.mapCtrl.integrateLandsatHotspotButton.title = $localize`activează/dezactivează Procesare hotspot/coolspot date satelitare`;
        $(this.mapCtrl.integrateLandsatHotspotButton).tooltip({placement: "right"});
        this.mapCtrl.integrateLandsatHotspotButtonCtrl = document.createElement('div');
        this.mapCtrl.integrateLandsatHotspotButtonCtrl.className = 'integrate-landsat-hotspot-button ol-unselectable left-tool-button';
        this.mapCtrl.integrateLandsatHotspotButtonCtrl.appendChild(this.mapCtrl.integrateLandsatHotspotButton);

        this.mapCtrl.integrateLandsatHotspotButton.addEventListener('click', (event) => { this.onClickIntegrateLandsatHotspotButton(event) });
        this.mapCtrl.leftButtonsTool.appendChild(this.mapCtrl.integrateLandsatHotspotButtonCtrl);
    }

    public onClickIntegrateLandsatHotspotButton(event: any){
        if ( this.mapCtrl.integrateLandsatHotspotButtonStateOn === false
            && this.mapCtrl.toolboxStateIsOn()){
            this.$log.log("toolbox activ");
            return;
        }
        //
        this.mapCtrl.integrateLandsatHotspotButtonStateOn = !this.mapCtrl.integrateLandsatHotspotButtonStateOn;
        //
        if (this.mapCtrl.integrateLandsatHotspotButtonStateOn){
            //
            if (this.mapCtrl.integrateLandsatHotspotData.funcInit){
                this.mapCtrl.integrateLandsatHotspotData.funcInit();
            }
        } else {
            //
            if (this.mapCtrl.integrateLandsatHotspotData.funcClear){
                this.mapCtrl.integrateLandsatHotspotData.funcClear();
            }
        }
    }

    public showIntegrateLandsatHotspotButtonIfHasAccess() {
        try {
            //check
            this.mapCtrl.integrateLandsatHotspotButtonStateVisible = this.mapCtrl.userSettingsSrvs.isAuthForResource(authAs.control_integrate_landsat_hotspot_button_visible, authType.object);
            let tmpdefaut = this.mapCtrl.userSettingsSrvs.isAuthForResource(authAs.control_integrate_landsat_hotspot_default_active, authType.object);
            if (this.mapCtrl.integrateLandsatHotspotButtonCtrl) {
                if (this.mapCtrl.integrateLandsatHotspotButtonStateVisible) {
                    $(this.mapCtrl.integrateLandsatHotspotButton).removeClass('greentop-button-hide');
                    this.mapCtrl.integrateLandsatHotspotButtonStateOn = tmpdefaut;
                    if (this.mapCtrl.integrateLandsatHotspotButtonStateOn) {
                        //this.initIntegrateLandsatHotspotTool();
                        if (this.mapCtrl.integrateLandsatHotspotData.funcInit){
                            this.mapCtrl.integrateLandsatHotspotData.funcInit();
                        }
                        
                    } else {
                        //this.clearIntegrateLandsatHotspotTool();
                        if (this.mapCtrl.integrateLandsatHotspotData.funcClear){
                            this.mapCtrl.integrateLandsatHotspotData.funcClear();
                        }
                    }
                } else {
                    $(this.mapCtrl.integrateLandsatHotspotButton).addClass('greentop-button-hide');
                    this.mapCtrl.integrateLandsatHotspotButtonStateOn = false;
                }
            }
        } catch (error) {
            this.$log.error("eroare afisare buton control integrate hotspot ");
        }

    }

    public addIntegrateLandsatDownloadButton() {
        this.mapCtrl.integrateLandsatDwonloadButton = document.createElement('button');
        this.mapCtrl.integrateLandsatDwonloadButton.innerHTML = '<i class="fas fa-arrow-alt-circle-down"></i>';
        this.mapCtrl.integrateLandsatDwonloadButton.title = $localize`activează/dezactivează Planificare descarcare date satelitare Integrate`;
        $(this.mapCtrl.integrateLandsatDwonloadButton).tooltip({placement: "right"});
        this.mapCtrl.integrateLandsatDwonloadButtonCtrl = document.createElement('div');
        this.mapCtrl.integrateLandsatDwonloadButtonCtrl.className = 'integrate-landsat-download-button ol-unselectable left-tool-button';
        this.mapCtrl.integrateLandsatDwonloadButtonCtrl.appendChild(this.mapCtrl.integrateLandsatDwonloadButton);

        this.mapCtrl.integrateLandsatDwonloadButton.addEventListener('click', (event) => { this.onClickintegrateLandsatDownloadButton(event) });
        this.mapCtrl.leftButtonsTool.appendChild(this.mapCtrl.integrateLandsatDwonloadButtonCtrl);
    }

    public onClickintegrateLandsatDownloadButton(event: any){
        if ( this.mapCtrl.integrateLandsatDwonloadButtonStateOn === false
            && this.mapCtrl.toolboxStateIsOn()){
            this.$log.log("toolbox activ");
            return;
        }
        //
        this.mapCtrl.integrateLandsatDwonloadButtonStateOn = !this.mapCtrl.integrateLandsatDwonloadButtonStateOn;
        // 
        if (this.mapCtrl.integrateLandsatDwonloadButtonStateOn){
            if (this.mapCtrl.integrateLandsatDownloadData.funcInit){
                this.mapCtrl.integrateLandsatDownloadData.funcInit();
            }
        } else {
            if (this.mapCtrl.integrateLandsatDownloadData.funcClear){
                this.mapCtrl.integrateLandsatDownloadData.funcClear();
            }
        }
    }

    public showIntegrateLandsatDwButtonIfHasAccess(){
        try {
            //check
            this.mapCtrl.integrateLandsatDwonloadButtonStateVisible = this.mapCtrl.userSettingsSrvs.isAuthForResource(authAs.control_integrate_landsat_dw_button_visible, authType.object);
            let tmpdefaut = this.mapCtrl.userSettingsSrvs.isAuthForResource(authAs.control_integrate_landsat_dw_default_active, authType.object);
            if (this.mapCtrl.integrateLandsatDwonloadButtonCtrl) {
                if (this.mapCtrl.integrateLandsatDwonloadButtonStateVisible ) {
                    $(this.mapCtrl.integrateLandsatDwonloadButtonCtrl).removeClass('integrate-landsat-button-hide');
                    this.mapCtrl.integrateLandsatDwonloadButtonStateOn = tmpdefaut;
                    if (this.mapCtrl.integrateLandsatDwonloadButtonStateOn){
                        if (this.mapCtrl.integrateLandsatDownloadData.funcInit){
                            this.mapCtrl.integrateLandsatDownloadData.funcInit();
                        }
                    } else {
                        if (this.mapCtrl.integrateLandsatDownloadData.funcClear){
                            this.mapCtrl.integrateLandsatDownloadData.funcClear();
                        }
                    }
                } else {
                    $(this.mapCtrl.integrateLandsatDwonloadButtonCtrl).addClass('integrate-landsat-button-hide');
                    this.mapCtrl.integrateLandsatDwonloadButtonStateOn = false;
                }
            }
        } catch (error) {
            this.$log.error("eroare afisare buton control integrateLandsat download ");
        }
        
    }
    //
    public addIntegrateLandsatProcIndConexButton() {
        this.mapCtrl.integrateLandsatProcIndConexButton = document.createElement('button');
        this.mapCtrl.integrateLandsatProcIndConexButton.innerHTML = '<i class="fas fa-gopuram"></i>';
        this.mapCtrl.integrateLandsatProcIndConexButton.title = $localize`activează/dezactivează Procesare indice conex`;
        $(this.mapCtrl.integrateLandsatProcIndConexButton).tooltip({placement: "right"});
        this.mapCtrl.integrateLandsatProcIndConexButtonCtrl = document.createElement('div');
        this.mapCtrl.integrateLandsatProcIndConexButtonCtrl.className = 'integrate-landsat-prindconex-button ol-unselectable left-tool-button';
        this.mapCtrl.integrateLandsatProcIndConexButtonCtrl.appendChild(this.mapCtrl.integrateLandsatProcIndConexButton);

        this.mapCtrl.integrateLandsatProcIndConexButton.addEventListener('click', (event) => { this.onClickintegrateLandsatProcIndConexButton(event) });
        this.mapCtrl.leftButtonsTool.appendChild(this.mapCtrl.integrateLandsatProcIndConexButtonCtrl);
    }

    public onClickintegrateLandsatProcIndConexButton(event: any){
        if ( this.mapCtrl.integrateLandsatProcIndConexButtonStateOn === false
            && this.mapCtrl.toolboxStateIsOn()){
            this.$log.log("toolbox activ");
            return;
        }
        //
        this.mapCtrl.integrateLandsatProcIndConexButtonStateOn = !this.mapCtrl.integrateLandsatProcIndConexButtonStateOn;
        // 
        if (this.mapCtrl.integrateLandsatProcIndConexButtonStateOn){
            if (this.mapCtrl.integrateLandsatProcIndConexData.funcInit){
                this.mapCtrl.integrateLandsatProcIndConexData.funcInit();
            }
        } else {
            if (this.mapCtrl.integrateLandsatProcIndConexData.funcClear){
                this.mapCtrl.integrateLandsatProcIndConexData.funcClear();
            }
        }
    }

    public showIntegrateLandsatPrButtonIfHasAccess(){
        try {
            //check
            this.mapCtrl.integrateLandsatProcIndConexButtonStateVisible = this.mapCtrl.userSettingsSrvs.isAuthForResource(authAs.control_integrate_landsat_prindconex_button_visible, authType.object);
            let tmpdefaut = this.mapCtrl.userSettingsSrvs.isAuthForResource(authAs.control_integrate_landsat_prindconex_default_active, authType.object);
            if (this.mapCtrl.integrateLandsatProcIndConexButtonCtrl) {
                if (this.mapCtrl.integrateLandsatProcIndConexButtonStateVisible ) {
                    $(this.mapCtrl.integrateLandsatProcIndConexButtonCtrl).removeClass('integrate-landsat-button-hide');
                    this.mapCtrl.integrateLandsatProcIndConexButtonStateOn = tmpdefaut;
                    if (this.mapCtrl.integrateLandsatProcIndConexButtonStateOn){
                        if (this.mapCtrl.integrateLandsatProcIndConexData.funcInit){
                            this.mapCtrl.integrateLandsatProcIndConexData.funcInit();
                        }
                    } else {
                        if (this.mapCtrl.integrateLandsatProcIndConexData.funcClear){
                            this.mapCtrl.integrateLandsatProcIndConexData.funcClear();
                        }
                    }
                } else {
                    $(this.mapCtrl.integrateLandsatProcIndConexButtonCtrl).addClass('integrate-landsat-button-hide');
                    this.mapCtrl.integrateLandsatProcIndConexButtonStateOn = false;
                }
            }
        } catch (error) {
            this.$log.error("eroare afisare buton control integrateLandsat ProcIndConex ");
        }
        
    }

    public addIntegrateLandsatProcDateSezoniereButton() {
        this.mapCtrl.integrateLandsatProcDateSezoniereButton = document.createElement('button');
        this.mapCtrl.integrateLandsatProcDateSezoniereButton.innerHTML = '<i class="fas fa-rainbow"></i>';
        this.mapCtrl.integrateLandsatProcDateSezoniereButton.title = $localize`activează/dezactivează Procesare date sezoniere`;
        $(this.mapCtrl.integrateLandsatProcDateSezoniereButton).tooltip({placement: "right"});
        this.mapCtrl.integrateLandsatProcDateSezoniereButtonCtrl = document.createElement('div');
        this.mapCtrl.integrateLandsatProcDateSezoniereButtonCtrl.className = 'integrate-landsat-prdtsez-button ol-unselectable left-tool-button';
        this.mapCtrl.integrateLandsatProcDateSezoniereButtonCtrl.appendChild(this.mapCtrl.integrateLandsatProcDateSezoniereButton);

        this.mapCtrl.integrateLandsatProcDateSezoniereButton.addEventListener('click', (event) => { this.onClickintegrateLandsatProcDateSezoniereButton(event) });
        this.mapCtrl.leftButtonsTool.appendChild(this.mapCtrl.integrateLandsatProcDateSezoniereButtonCtrl);
    }

    public onClickintegrateLandsatProcDateSezoniereButton(event: any){
        if ( this.mapCtrl.integrateLandsatProcDateSezoniereButtonStateOn === false
            && this.mapCtrl.toolboxStateIsOn()){
            this.$log.log("toolbox activ");
            return;
        }
        //
        this.mapCtrl.integrateLandsatProcDateSezoniereButtonStateOn = !this.mapCtrl.integrateLandsatProcDateSezoniereButtonStateOn;
        // 
        if (this.mapCtrl.integrateLandsatProcDateSezoniereButtonStateOn){
            if (this.mapCtrl.integrateLandsatProcDateSezoniereData.funcInit){
                this.mapCtrl.integrateLandsatProcDateSezoniereData.funcInit();
            }
        } else {
            if (this.mapCtrl.integrateLandsatProcDateSezoniereData.funcClear){
                this.mapCtrl.integrateLandsatProcDateSezoniereData.funcClear();
            }
        }
    }

    public showIntegrateLandsatDateSezoniereButtonIfHasAccess(){
        try {
            //check
            this.mapCtrl.integrateLandsatProcDateSezoniereButtonStateVisible = this.mapCtrl.userSettingsSrvs.isAuthForResource(authAs.control_integrate_landsat_prdtsezonier_button_visible, authType.object);
            let tmpdefaut = this.mapCtrl.userSettingsSrvs.isAuthForResource(authAs.control_integrate_landsat_prdtsezonier_default_active, authType.object);
            if (this.mapCtrl.integrateLandsatProcDateSezoniereButtonCtrl) {
                if (this.mapCtrl.integrateLandsatProcDateSezoniereButtonStateVisible ) {
                    $(this.mapCtrl.integrateLandsatProcDateSezoniereButtonCtrl).removeClass('integrate-landsat-button-hide');
                    this.mapCtrl.integrateLandsatProcDateSezoniereButtonStateOn = tmpdefaut;
                    if (this.mapCtrl.integrateLandsatProcDateSezoniereButtonStateOn){
                        if (this.mapCtrl.integrateLandsatProcDateSezoniereData.funcInit){
                            this.mapCtrl.integrateLandsatProcDateSezoniereData.funcInit();
                        }
                    } else {
                        if (this.mapCtrl.integrateLandsatProcDateSezoniereData.funcClear){
                            this.mapCtrl.integrateLandsatProcDateSezoniereData.funcClear();
                        }
                    }
                } else {
                    $(this.mapCtrl.integrateLandsatProcDateSezoniereButtonCtrl).addClass('integrate-landsat-button-hide');
                    this.mapCtrl.integrateLandsatProcDateSezoniereButtonStateOn = false;
                }
            }
        } catch (error) {
            this.$log.error("eroare afisare buton control integrateLandsat ProcDateSezoniere ");
        }
        
    }
    //
    public addGreentopDownloadButton() {
        this.mapCtrl.greentopDwonloadButton = document.createElement('button');
        this.mapCtrl.greentopDwonloadButton.innerHTML = '<i class="fas fa-arrow-alt-circle-down"></i>';
        this.mapCtrl.greentopDwonloadButton.title = $localize`activează/dezactivează Planificare descărcare date satelitare`;
        $(this.mapCtrl.greentopDwonloadButton).tooltip({placement: "right"});
        this.mapCtrl.greentopDwonloadButtonCtrl = document.createElement('div');
        this.mapCtrl.greentopDwonloadButtonCtrl.className = 'greentop-download-button ol-unselectable left-tool-button';
        this.mapCtrl.greentopDwonloadButtonCtrl.appendChild(this.mapCtrl.greentopDwonloadButton);

        this.mapCtrl.greentopDwonloadButton.addEventListener('click', (event) => { this.onClickgreentopDownloadButton(event) });
       this.mapCtrl.leftButtonsTool.appendChild(this.mapCtrl.greentopDwonloadButtonCtrl);
    }
    //
    public onClickgreentopDownloadButton(event: any){
        if ( this.mapCtrl.greentopDwonloadButtonStateOn === false
            && this.mapCtrl.toolboxStateIsOn()){
            this.$log.log("toolbox activ");
            return;
        }
        if (this.mapCtrl.greentopClassifyMinimizeStateOn === true){
            this.$log.log("tool clasificare activ");
            return;
        }
        //
        this.mapCtrl.greentopDwonloadButtonStateOn = !this.mapCtrl.greentopDwonloadButtonStateOn;
        // todo
        if (this.mapCtrl.greentopDwonloadButtonStateOn){
            if (this.mapCtrl.greentopDownloadData.funcInit){
                this.mapCtrl.greentopDownloadData.funcInit();
            }
        } else {
            if (this.mapCtrl.greentopDownloadData.funcClear){
                this.mapCtrl.greentopDownloadData.funcClear();
            }
        }
    }
    //
    public showGreentopDwButtonIfHasAccess(){
        try {
            //check
            this.mapCtrl.greentopDwonloadButtonStateVisible = this.mapCtrl.userSettingsSrvs.isAuthForResource(authAs.control_grentop_dw_button_visible, authType.object);
            let tmpdefaut = this.mapCtrl.userSettingsSrvs.isAuthForResource(authAs.control_grentop_dw_default_active, authType.object);
            if (this.mapCtrl.greentopDwonloadButtonCtrl) {
                if (this.mapCtrl.greentopDwonloadButtonStateVisible ) {
                    $(this.mapCtrl.greentopDwonloadButtonCtrl).removeClass('greentop-button-hide');
                    this.mapCtrl.greentopDwonloadButtonStateOn = tmpdefaut;
                    if (this.mapCtrl.greentopDwonloadButtonStateOn){
                        if (this.mapCtrl.greentopDownloadData.funcInit){
                            this.mapCtrl.greentopDownloadData.funcInit();
                        }
                    } else {
                        if (this.mapCtrl.greentopDownloadData.funcClear){
                            this.mapCtrl.greentopDownloadData.funcClear();
                        }
                    }
                } else {
                    $(this.mapCtrl.greentopDwonloadButtonCtrl).addClass('greentop-button-hide');
                    this.mapCtrl.greentopDwonloadButtonStateOn = false;
                }
            }
        } catch (error) {
            this.$log.error("eroare afisare buton control greentop download ");
        }
        
    }

    //
    public addGreentopTrainingButton() {
        this.mapCtrl.greentopTrainingButton = document.createElement('button');
        this.mapCtrl.greentopTrainingButton.innerHTML = '<i class="fas fa-brain"></i>';
        this.mapCtrl.greentopTrainingButton.title = $localize`activează/dezactivează Planificare antrenament model clasificare`;
        $(this.mapCtrl.greentopTrainingButton).tooltip({placement: "right"});
        this.mapCtrl.greentopTrainingButtonCtrl = document.createElement('div');
        this.mapCtrl.greentopTrainingButtonCtrl.className = 'greentop-training-button ol-unselectable left-tool-button';
        this.mapCtrl.greentopTrainingButtonCtrl.appendChild(this.mapCtrl.greentopTrainingButton);

        this.mapCtrl.greentopTrainingButton.addEventListener('click', (event) => { this.onClickgreentopTrainingButton(event) });
        this.mapCtrl.leftButtonsTool.appendChild(this.mapCtrl.greentopTrainingButtonCtrl);
    }
    //
    public onClickgreentopTrainingButton(event: any) {
        if (this.mapCtrl.greentopTrainingButtonStateOn === false
            && this.mapCtrl.toolboxStateIsOn()) {
            this.$log.log("toolbox activ");
            return;
        }
        if (this.mapCtrl.greentopClassifyMinimizeStateOn === true){
            this.$log.log("tool clasificare activ");
            return;
        }
        //
        this.mapCtrl.greentopTrainingButtonStateOn = !this.mapCtrl.greentopTrainingButtonStateOn;
        // 
        if (this.mapCtrl.greentopTrainingButtonStateOn) {
            if (this.mapCtrl.greentopTrainingData.funcInit){
                this.mapCtrl.greentopTrainingData.funcInit();
            }
        } else {
            if (this.mapCtrl.greentopTrainingData.funcClear){
                this.mapCtrl.greentopTrainingData.funcClear();
            }
        }
    }
    //
    public showGreentopTrButtonIfHasAccess() {
        try {
            //check
            this.mapCtrl.greentopTrainingButtonStateVisible = this.mapCtrl.userSettingsSrvs.isAuthForResource(authAs.control_grentop_tr_button_visible, authType.object);
            let tmpdefaut = this.mapCtrl.userSettingsSrvs.isAuthForResource(authAs.control_grentop_tr_default_active, authType.object);
            if (this.mapCtrl.greentopTrainingButtonCtrl) {
                if (this.mapCtrl.greentopTrainingButtonStateVisible) {
                    $(this.mapCtrl.greentopTrainingButtonCtrl).removeClass('greentop-button-hide');
                    this.mapCtrl.greentopTrainingButtonStateOn = tmpdefaut;
                    if (this.mapCtrl.greentopTrainingButtonStateOn) {
                        if (this.mapCtrl.greentopTrainingData.funcInit){
                            this.mapCtrl.greentopTrainingData.funcInit();
                        }
                    } else {
                        if (this.mapCtrl.greentopTrainingData.funcClear){
                            this.mapCtrl.greentopTrainingData.funcClear();
                        }
                    }
                } else {
                    $(this.mapCtrl.greentopTrainingButtonCtrl).addClass('greentop-button-hide');
                    this.mapCtrl.greentopTrainingButtonStateOn = false;
                }
            }
        } catch (error) {
            this.$log.error("eroare afisare buton control greentop training ");
        }

    }
    //
    public addGreentopClassifyButton() {
        this.mapCtrl.greentopClassifyButton = document.createElement('button');
        this.mapCtrl.greentopClassifyButton.innerHTML = '<i class="fas fa-globe-europe"></i>';
        this.mapCtrl.greentopClassifyButton.title = $localize`activează/dezactivează Planificare clasificare date satelitare`;
        $(this.mapCtrl.greentopClassifyButton).tooltip({placement: "right"});
        this.mapCtrl.greentopClassifyButtonCtrl = document.createElement('div');
        this.mapCtrl.greentopClassifyButtonCtrl.className = 'greentop-classify-button ol-unselectable left-tool-button';
        this.mapCtrl.greentopClassifyButtonCtrl.appendChild(this.mapCtrl.greentopClassifyButton);

        this.mapCtrl.greentopClassifyButton.addEventListener('click', (event) => { this.onClickgreentopClassifyButton(event) });
        this.mapCtrl.leftButtonsTool.appendChild(this.mapCtrl.greentopClassifyButtonCtrl);
    }

    public onClickgreentopClassifyButton(event: any) {
        if (this.mapCtrl.greentopClassifyButtonStateOn === false
            && this.mapCtrl.toolboxStateIsOn()) {
            this.$log.log("toolbox activ");
            return;
        }
        //
        this.mapCtrl.greentopClassifyButtonStateOn = !this.mapCtrl.greentopClassifyButtonStateOn;
        // todo
        if (this.mapCtrl.greentopClassifyButtonStateOn) {
            if(this.mapCtrl.greentopClassifyMinimizeStateOn === false){
                if (this.mapCtrl.greentopClassifyData.funcInit){
                    this.mapCtrl.greentopClassifyData.funcInit();
                }
            } else {
                this.mapCtrl.greentopClassifyMinimizeStateOn = false;
                $(this.mapCtrl.greentopClassifyButtonCtrl).removeClass('select-button-on');
            }
        } else {
            if (this.mapCtrl.greentopClassifyData.funcClear){
                this.mapCtrl.greentopClassifyData.funcClear();
            }
        }
    }
    public showGreentopClButtonIfHasAccess() {
        try {
            //check
            this.mapCtrl.greentopClassifyButtonStateVisible = this.mapCtrl.userSettingsSrvs.isAuthForResource(authAs.control_grentop_cl_button_visible, authType.object);
            let tmpdefaut = this.mapCtrl.userSettingsSrvs.isAuthForResource(authAs.control_grentop_cl_default_active, authType.object);
            if (this.mapCtrl.greentopClassifyButtonCtrl) {
                if (this.mapCtrl.greentopClassifyButtonStateVisible) {
                    $(this.mapCtrl.greentopClassifyButtonCtrl).removeClass('greentop-button-hide');
                    this.mapCtrl.greentopClassifyButtonStateOn = tmpdefaut;
                    //
                    if (this.mapCtrl.greentopClassifyButtonStateOn) {
                        if (this.mapCtrl.greentopClassifyData.funcInit){
                            this.mapCtrl.greentopClassifyData.funcInit();
                        }
                    } else {
                        if (this.mapCtrl.greentopClassifyData.funcClear){
                            this.mapCtrl.greentopClassifyData.funcClear();
                        }
                    }
                } else {
                    $(this.mapCtrl.greentopClassifyButtonCtrl).addClass('greentop-button-hide');
                    this.mapCtrl.greentopClassifyButtonStateOn = false;
                }
            }
        } catch (error) {
            this.$log.error("eroare afisare buton control greentop classify ");
        }

    }

   
    //
    //
    public addTranzitButton() {
        this.mapCtrl.tranzitButton = document.createElement('button');
        this.mapCtrl.tranzitButton.innerHTML = '<i class="fas fa-route"></i>';
        this.mapCtrl.tranzitButton.title = $localize`activează/dezactivează Planificare călătorie`;
        $(this.mapCtrl.tranzitButton).tooltip({placement: "right"});
        this.mapCtrl.tranzitButtonCtrl = document.createElement('div');
        this.mapCtrl.tranzitButtonCtrl.className = 'tranzit-button ol-unselectable left-tool-button';
        this.mapCtrl.tranzitButtonCtrl.appendChild(this.mapCtrl.tranzitButton);

        this.mapCtrl.tranzitButton.addEventListener('click', (event) => { this.onClickTranzitButton(event) });
        this.mapCtrl.leftButtonsTool.appendChild(this.mapCtrl.tranzitButtonCtrl);
    }


    public onClickTranzitButton(event: any){
        if ( this.mapCtrl.tranzitButtonStateOn === false
            && this.mapCtrl.toolboxStateIsOn()){
            this.$log.log("toolbox activ");
            return;
        }
        if (this.mapCtrl.greentopClassifyMinimizeStateOn === true){
            this.$log.log("tool clasificare activ");
            return;
        }
        //
        this.mapCtrl.tranzitButtonStateOn = !this.mapCtrl.tranzitButtonStateOn;
        // todo
        if (this.mapCtrl.tranzitButtonStateOn){
            if (this.mapCtrl.tranzitData.funcInit){
                this.mapCtrl.tranzitData.funcInit();
            }
        } else {
            if (this.mapCtrl.tranzitData.funcClear){
                this.mapCtrl.tranzitData.funcClear();
            }
        }

    }
    //
    public showTranzitButtonIfHasAccess(){
        try {
            //check
            this.mapCtrl.tranzitButtonStateVisible = this.mapCtrl.userSettingsSrvs.isAuthForResource(authAs.control_tranzit_button_visible, authType.object);
            let tmpdefaut = this.mapCtrl.userSettingsSrvs.isAuthForResource(authAs.control_tranzit_default_active, authType.object);
            if (this.mapCtrl.tranzitButtonCtrl) {
                if (this.mapCtrl.tranzitButtonStateVisible ) {
                    $(this.mapCtrl.tranzitButtonCtrl).removeClass('tranz-button-hide');
                    this.mapCtrl.tranzitButtonStateOn = tmpdefaut;
                    setTimeout(()=>{
                        if (this.mapCtrl.tranzitButtonStateOn){
                            if (this.mapCtrl.tranzitData.funcInit){
                                this.mapCtrl.tranzitData.funcInit();
                            }
                        } else {
                            if (this.mapCtrl.tranzitData.funcClear){
                                this.mapCtrl.tranzitData.funcClear();
                            }
                        }
                    },500);
                } else {
                    $(this.mapCtrl.tranzitButtonCtrl).addClass('tranz-button-hide');
                    this.mapCtrl.tranzitButtonStateOn = false;
                }
            }
        } catch (error) {
            this.$log.error("eroare afisare buton control tranzit ");
        }
        
    }
    public addLocationBButton() {
        this.mapCtrl.locationBButton = document.createElement('button');
        this.mapCtrl.locationBButton.innerHTML = '<i class="fas fa-map-marked"></i>';
        this.mapCtrl.locationBButton.title = $localize`activează/dezactivează căutare locație adresă personalizata`;
        $(this.mapCtrl.locationBButton).tooltip({placement: "right"});
        this.mapCtrl.locationBButtonCtrl = document.createElement('div');
        this.mapCtrl.locationBButtonCtrl.className = 'position-button ol-unselectable left-tool-button';
        this.mapCtrl.locationBButtonCtrl.appendChild(this.mapCtrl.locationBButton);

        this.mapCtrl.locationBButton.addEventListener('click',(event) => { this.onClickLocationBButton(event);});
        this.mapCtrl.leftButtonsTool.appendChild(this.mapCtrl.locationBButtonCtrl);
    }
    public onClickLocationBButton = (event) => {
        if ( this.mapCtrl.locationBButtonStateOn === false
            && this.mapCtrl.toolboxStateIsOn()){
            this.$log.log("toolbox activ");
            return;
        }
        //
        this.mapCtrl.locationBButtonStateOn = !this.mapCtrl.locationBButtonStateOn;
        //
        if (this.mapCtrl.locationBButtonStateOn){
            if (this.mapCtrl.locationBData.funcInit){
                this.mapCtrl.locationBData.funcInit();
            }
        } else {
            if (this.mapCtrl.locationBData.funcClear){
                this.mapCtrl.locationBData.funcClear();
            }
        }
        
    }
    public showLocationBButtonIfHasAccess(){
        try {
            //check
            this.mapCtrl.locationBButtonStateVisible = this.mapCtrl.userSettingsSrvs.isAuthForResource(authAs.control_location_custom_b_button_visible, authType.object);
            let tmpdefaut = this.mapCtrl.userSettingsSrvs.isAuthForResource(authAs.control_location_custom_b_default_active, authType.object);
            if (this.mapCtrl.locationBButtonCtrl) {
                if (this.mapCtrl.locationBButtonStateVisible ) {
                    $(this.mapCtrl.locationBButtonCtrl).removeClass('tranz-button-hide');
                    this.mapCtrl.locationBButtonStateOn = tmpdefaut;
                    setTimeout(()=>{
                        if (this.mapCtrl.locationBButtonStateOn){
                            if (this.mapCtrl.locationBData.funcInit){
                                this.mapCtrl.locationBData.funcInit();
                            }
                        } else {
                            if (this.mapCtrl.locationBData.funcClear){
                                this.mapCtrl.locationBData.funcClear();
                            }
                        }
                    },500);
                } else {
                    $(this.mapCtrl.locationBButtonCtrl).addClass('tranz-button-hide');
                    this.mapCtrl.locationBButtonStateOn = false;
                }
            }
        } catch (error) {
            this.$log.error("eroare afisare buton control locationB ");
        }
        
    }


     public addHelpButton() {
        this.mapCtrl.helpButton = document.createElement('button');
        this.mapCtrl.helpButton.innerHTML = '<i class="fas fa-book"></i>';
        this.mapCtrl.helpButton.title = $localize`deschide manual utilizare aplicatie`;
        $(this.mapCtrl.helpButton).tooltip({placement: "right"});
        this.mapCtrl.helpButtonCtrl = document.createElement('div');
        this.mapCtrl.helpButtonCtrl.className = 'position-button ol-unselectable left-tool-button';
        this.mapCtrl.helpButtonCtrl.appendChild(this.mapCtrl.helpButton);

        this.mapCtrl.helpButton.addEventListener('click',(event) => { this.onClickHelpButton(event);});
        this.mapCtrl.leftButtonsTool.appendChild(this.mapCtrl.helpButtonCtrl);
    }
    public onClickHelpButton = (event) => {
        //
        try {
            const pdfUrl = 'docs/Manual_de_utilizare_GIS.pdf';
            const newWindow = window.open(pdfUrl, '_blank');
            
            if (!newWindow) {
                // Popup blocked
                this.$log.warn('Popup blocked. Please allow popups for this site.');
                alert('Te rugăm să activezi popup-urile pentru a deschide manualul.');
            }
        } catch (error) {
            this.$log.error('Error opening PDF: ' + error.message);
        }
    }
    public showHelpButtonIfHasAccess(){
        try {
            //check
            this.mapCtrl.helpButtonStateVisible = this.mapCtrl.userSettingsSrvs.isAuthForResource(authAs.control_help_button_visible, authType.object);
            if (this.mapCtrl.helpButtonCtrl) {
                if (this.mapCtrl.helpButtonStateVisible ) {
                    $(this.mapCtrl.helpButtonCtrl).removeClass('help-button-hide');
                } else {
                    $(this.mapCtrl.helpButtonCtrl).addClass('help-button-hide');
                }
            }
        } catch (error) {
            this.$log.error("eroare afisare buton control help ");
        }
        
    }

    public addMapImageEditButton() {
        this.mapCtrl.mapImageEditButton = document.createElement('button');
        this.mapCtrl.mapImageEditButton.innerHTML = '<i class="fas fa-camera"></i>';
        this.mapCtrl.mapImageEditButton.title = $localize`captură imagine hartă și editare`;
        $(this.mapCtrl.mapImageEditButton).tooltip({ placement: "right" });
        this.mapCtrl.mapImageEditButtonCtrl = document.createElement('div');
        this.mapCtrl.mapImageEditButtonCtrl.className = 'position-button ol-unselectable left-tool-button';
        this.mapCtrl.mapImageEditButtonCtrl.appendChild(this.mapCtrl.mapImageEditButton);

        this.mapCtrl.mapImageEditButton.addEventListener('click', (event) => { this.onClickMapImageEditButton(event); });
        this.mapCtrl.leftButtonsTool.appendChild(this.mapCtrl.mapImageEditButtonCtrl);
    }

    public onClickMapImageEditButton = (event) => {
        this.mapCtrl.map.once('postrender', () => {
            if (this.mapCtrl.mapImgUrl) {
                URL.revokeObjectURL(this.mapCtrl.mapImgUrl);
                this.mapCtrl.mapImgUrl = '';
            }

            const canvas = this.mapCtrl.mapCtrlSelectBox.mapCanvasForImage();
            const openEditor = (imageUrl: string) => {
                this.mapCtrl.mapImgUrl = imageUrl;
                this.mapCtrl.showEditMapImageDialog(this.mapCtrl.mapImgUrl)
                    .then((result) => {
                        // Download only when modal explicitly returns a saved image.
                        if (result && result.mapImgUrl) {
                            this.downloadMapImage(result.mapImgUrl);
                        }
                    })
                    .catch(() => {
                        // modal dismissed
                    })
                    .finally(() => {
                        if (this.mapCtrl.mapImgUrl && this.mapCtrl.mapImgUrl.startsWith('blob:')) {
                            URL.revokeObjectURL(this.mapCtrl.mapImgUrl);
                        }
                        this.mapCtrl.mapImgUrl = '';
                    });
            };

            if ("toBlob" in canvas) {
                canvas.toBlob((blob) => {
                    if (blob) {
                        openEditor(URL.createObjectURL(blob));
                    }
                });
            } else if ("msToBlob" in canvas) {
                const blob = (canvas as any).msToBlob();
                openEditor(URL.createObjectURL(blob));
            } else {
                openEditor((canvas as HTMLCanvasElement).toDataURL('image/png'));
            }
        });
        this.mapCtrl.map.renderSync();
    }
     public showImageEditButtonIfHasAccess(){
        try {
            //check
            this.mapCtrl.mapImageEditButtonStateVisible = this.mapCtrl.userSettingsSrvs.isAuthForResource(authAs.control_map_image_edit_visible, authType.object);
            if (this.mapCtrl.mapImageEditButtonCtrl) {
                if (this.mapCtrl.mapImageEditButtonStateVisible ) {
                    $(this.mapCtrl.mapImageEditButtonCtrl).removeClass('map-image-edit-button-hide');
                } else {
                    $(this.mapCtrl.mapImageEditButtonCtrl).addClass('map-image-edit-button-hide');
                }
            }
        } catch (error) {
            this.$log.error("eroare afisare buton control edit image button ");
        }
        
    }

    private downloadMapImage(imageUrl: string): void {
        const link = document.createElement('a');
        link.href = imageUrl;
        link.download = `map-snapshot-${new Date().getTime()}.png`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }



    //Map individual controls
    //
    public addPositionMarkerButton() {
        this.mapCtrl.positionMarkerButton = document.createElement('button');
        this.mapCtrl.positionMarkerButton.innerHTML = '<i class="fas fa-map-marked-alt"></i>';
        this.mapCtrl.positionMarkerButton.title = $localize`activează/dezactivează căutare locație adresă și localizare gps`;
        $(this.mapCtrl.positionMarkerButton).tooltip({placement: "right"});
        this.mapCtrl.positionMarkerButtonCtrl = document.createElement('div');
        this.mapCtrl.positionMarkerButtonCtrl.className = 'position-button ol-unselectable left-tool-button';
        this.mapCtrl.positionMarkerButtonCtrl.appendChild(this.mapCtrl.positionMarkerButton);

        this.mapCtrl.positionMarkerButton.addEventListener('click', this.onClickPositionMarkerButton);
        this.mapCtrl.leftButtonsTool.appendChild(this.mapCtrl.positionMarkerButtonCtrl);
    }
    public onClickPositionMarkerButton = (event) => {
        if ( this.mapCtrl.positionButtonStateOn === false
            && this.mapCtrl.toolboxStateIsOn()){
            this.$log.log("toolbox activ");
            return;
        }
        //
        this.mapCtrl.positionButtonStateOn = !this.mapCtrl.positionButtonStateOn;
        //
        if (this.mapCtrl.positionButtonStateOn){
            if (this.mapCtrl.positionData.funcInit){
                this.mapCtrl.positionData.funcInit();
            }
        } else {
            if (this.mapCtrl.positionData.funcClear){
                this.mapCtrl.positionData.funcClear();
            }
        }
        
    }
    public buildPositionMarkerOverlay() {
        this.mapCtrl.positionMarkerOverlay = new Overlay({
            positioning: 'center-center',
            element: document.getElementById('location-marker'),
            stopEvent: false
        });
        this.mapCtrl.geoLocation = new Geolocation({
            projection: this.mapCtrl.map.getView().getProjection()
        });
        this.mapCtrl.geoLocation.on('change:position', () => {
            this.mapCtrl.positionMarkerOverlay.setPosition(this.mapCtrl.geoLocation.getPosition());
            this.mapCtrl.map.getView().setCenter(this.mapCtrl.geoLocation.getPosition());
            this.$log.log("position changed");
        });

    }

    //
    addCtrlMousePosition() {
        if (this.mapCtrl.userSettingsSrvs.isAuthForResource(authAs.control_coordinates_visible, authType.object)) {
            let proj = 'EPSG:4326';
            if (this.mapCtrl.userSettingsSrvs.isAuthForResource(authAs.control_coordinates_use_map_projection, authType.object)) {
                proj = this.mapCtrl.mapConfig.projection;
            }
            if (this.mapCtrl.mousePositionCtrl != null) {
                try {
                    this.mapCtrl.map.removeControl(this.mapCtrl.mousePositionCtrl);
                } catch (e) {
                    this.$log.error('remove mouse position control error: ', getExMessage(e));
                }

            }
            // Determine decimal places based on projection units
            const projection = olProj.get(proj);
            const metersPerUnit = projection.getMetersPerUnit();

            // Meter-based projections (EPSG:3857, UTM, etc.) use 0 decimals
            // Degree-based projections (EPSG:4326) use 5 decimals
            const decimals = metersPerUnit === 1 ? 0 : 5;
            this.mapCtrl.mousePositionCtrl = new MousePosition({
                coordinateFormat: olCoordinate.createStringXY(decimals),
                projection: proj
            });
            this.mapCtrl.map.addControl(this.mapCtrl.mousePositionCtrl);
        } else {
            if (this.mapCtrl.mousePositionCtrl != null) {
                try {
                    this.mapCtrl.map.removeControl(this.mapCtrl.mousePositionCtrl);
                } catch (e) {
                    this.$log.error('remove mouse position control error: ' , getExMessage(e));
                }
            }
        }
    }
    //
    addCtrlScaleBar() {
        if (this.mapCtrl.userSettingsSrvs.isAuthForResource(authAs.control_scale_bar_visible, authType.object)) {
            if (this.mapCtrl.scaleBarCtrl != null) {
                try {
                    this.mapCtrl.map.removeControl(this.mapCtrl.scaleBarCtrl);
                } catch (e) {
                    this.$log.error('remove bara scala control error: ', getExMessage(e));
                }

            }
            this.mapCtrl.scaleBarCtrl = new ScaleLine({
                units: "metric",
                bar: true,
                steps: 4,
                text: true,
                maxWidth: 200,
            });
            this.mapCtrl.map.addControl(this.mapCtrl.scaleBarCtrl);
        } else {
            if (this.mapCtrl.scaleBarCtrl != null) {
                try {
                    this.mapCtrl.map.removeControl(this.mapCtrl.scaleBarCtrl);
                } catch (e) {
                    this.$log.error('emove bara scala control error: ' , getExMessage(e));
                }
            }
        }
    }
    //control_north_marker_visible
    addCtrlNorthMarker() {
        if (this.mapCtrl.userSettingsSrvs.isAuthForResource(authAs.control_north_marker_visible, authType.object)) {
            if (this.mapCtrl.northMarkCtrl != null) {
                try {
                    this.mapCtrl.map.removeControl(this.mapCtrl.northMarkCtrl);
                } catch (e) {
                    this.$log.error('remove indicator nord control error: ', getExMessage(e));
                }

            }
            this.mapCtrl.northMarkCtrl =  new Compass ({
                className: "bottom",
                src: "default",
                rotateVithView: true,
                style: new Stroke ({ color: "blue", width:  0 })
                });
            this.mapCtrl.map.addControl(this.mapCtrl.northMarkCtrl);
        } else {
            if (this.mapCtrl.northMarkCtrl != null) {
                try {
                    this.mapCtrl.map.removeControl(this.mapCtrl.northMarkCtrl);
                } catch (e) {
                    this.$log.error('emove indicator nord control error: ' , getExMessage(e));
                }
            }
        }
    }
    //
    public addLegendButton() {
        this.mapCtrl.legendButton = document.createElement('button');
        this.mapCtrl.legendButton.innerHTML = '<i class="fas fa-atlas"></i>';
        this.mapCtrl.legendButton.title = $localize`activează/dezactivează legendă`;
        $(this.mapCtrl.legendButton).tooltip();
        let element = document.createElement('div');
        element.className = 'legend-button ol-unselectable ol-control';
        element.appendChild(this.mapCtrl.legendButton);

        this.mapCtrl.legendButtonCtrl = new Control({
            element: element
        });

        this.mapCtrl.legendButton.addEventListener('click', this.onClickLengendButton);
        this.mapCtrl.map.addControl(this.mapCtrl.legendButtonCtrl);
        this.mapCtrl.legendContent = document.getElementById("legendContent") as HTMLDivElement;
    }
    //
    public onClickLengendButton = (event) => {
        this.mapCtrl.legendButtonStateOn = !this.mapCtrl.legendButtonStateOn;
    }

    public showCesium3DButtonIfHasAccess() {
        try {
            //
            this.mapCtrl.cesium3DButtonStateVisible = this.mapCtrl.userSettingsSrvs.isAuthForResource(authAs.control_3d_cesium_button_visible, authType.object);
            let tmpdefaut = this.mapCtrl.userSettingsSrvs.isAuthForResource(authAs.control_3d_cesium_default_active, authType.object);
            
                if (this.mapCtrl.cesium3DButtonStateVisible) {
                    this.mapCtrl.cesium3DButtonStateOn = tmpdefaut;
                    if (this.mapCtrl.cesium3DButtonStateOn) {
                        if (!this.mapCtrl.is3DEnabled()){
                            this.mapCtrl.toggle3D();
                        }
                        
                    } else {
                       if (this.mapCtrl.is3DEnabled()){
                            this.mapCtrl.toggle3D();
                        }
                    }
                } else {
                    this.mapCtrl.cesium3DButtonStateOn = false;
                    if (this.mapCtrl.is3DEnabled()){
                            this.mapCtrl.toggle3D();
                        }
                }
            
        } catch (error) {
            this.$log.error("eroare afisare buton control 3d cesium ");
        }

    }


}